export const en = {
    emptyPrice: 'none'
};
